export default {
  workDays: [
    {
      name: 'Poniedziałek',
      number: 1,
    },
    {
      name: 'Wtorek',
      number: 2,
    },
    {
      name: 'Środa',
      number: 3,
    },
    {
      name: 'Czwartek',
      number: 4,
    },
    {
      name: 'Piątek',
      number: 5,
    },
    {
      name: 'Sobota',
      number: 6,
    },
    {
      name: 'Niedziela',
      number: 0,
    },
  ]
}